import { buildUrl, usKidsGolfService } from '@/libs/api/instances/us-kids-golf-instance';
import type { RequestOptions } from '@/libs/api/types';

/** Path (relative to `buildUrl`) for the guardian bug report / "Report an issue" submission. */
export const BUG_REPORT_ENDPOINT = '/bug-report';

/**
 * Body for POST `/api/v1/bug-report`.
 * Identity comes from the signed-in Firebase token on the backend — only issue detail +
 * already-uploaded attachment URLs are sent in the body.
 */
export type SubmitBugReportRequest = {
  /** Short issue title (required). */
  issue: string;
  /** Optional extra detail. */
  description?: string;
  /** Firebase Storage download URLs for screenshots / recordings uploaded before submit. */
  attachments?: string[];
};

/**
 * Sends a bug report via POST `/api/v1/bug-report`. Authenticated automatically with the
 * signed-in guardian's Firebase token; the backend emails the H&L team.
 */
export async function submitBugReport(
  body: SubmitBugReportRequest,
  options?: RequestOptions,
): Promise<void> {
  await usKidsGolfService.post<void, SubmitBugReportRequest>(
    buildUrl(BUG_REPORT_ENDPOINT),
    body,
    options,
  );
}
